import { connect } from 'react-redux';

import GroupSetListItem from './GroupSetListItem';

import {
  selectors as groupSelectors,
  operations as groupOperations,
} from '../../../../store/groups';
import { currentUser } from '../../../../../core/selectors/user';
import { isInstructor } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, ownProps) => {
  const set = groupSelectors.groupSet(state, ownProps.set) || {};
  const user = currentUser(state);
  const isCurrentUserInstructor = isInstructor(state, user.objectId);

  return {
    name: set.name,
    isHidden: set.isHidden,
    isLocked: set.isLocked,
    groups: set.groups,
    isInstructor: isCurrentUserInstructor,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onEditGroupSet: () =>
    dispatch(groupOperations.openEditGroupSet(ownProps.set)),
  onCreateGroup: () => dispatch(groupOperations.openAddGroup(ownProps.set)),
  onGenerateGroups: () =>
    dispatch(groupOperations.openGenerateGroups(ownProps.set)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupSetListItem);
